export const photographyMap = {
    bodyWater1: {
        name: "Body & Water",
        file: "/assets/photography/bodyWater1.jpg",
    },
    bodyWater2: {
        name: "Body and Water",
        file: "/assets/photography/bodyWater2.jpg",
    },
    bodyWater3: {
        name: "Body and Water",
        file: "/assets/photography/bodyWater3.jpg",
    },
    bridgeLight: {
        name: "Bridge light",
        file: "/assets/photography/bridgeLight.jpeg",
    },
    contrasteRouge: {
        file: "/assets/photography/contrasteRouge.jpeg",
    },
    faceClose: {
        file: "/assets/photography/faceClose.jpeg",
    },
    faceClose2: {
        file: "/assets/photography/faceClose2.jpeg",
    },
    graphicalDetail: {
        file: "/assets/photography/graphicalDetail.jpeg",
    },
    jumpingMan: {
        file: "/assets/photography/jumpingMan.jpeg",
    },
    lightClose1: {
        file: "/assets/photography/lightClose1.jpeg",
    },
    lightClose2: {
        file: "/assets/photography/lightClose2.jpeg",
    },
    lightClose3: {
        file: "/assets/photography/lightClose3.jpeg",
    },
    manAbove: {
        file: "/assets/photography/manAbove.jpeg",
    },
    manClose: {
        file: "/assets/photography/manClose.jpeg",
    },
    movingMan: {
        file: "/assets/photography/movingMan.jpeg",
    },
    parkingIndoor: {
        file: "/assets/photography/parkingIndoor.jpeg",
    },
    portraitMan: {
        file: "/assets/photography/portraitMan.jpeg",
    },
    portraitWoman1: {
        file: "/assets/photography/portraitWoman1.jpeg",
    },
    portraitWoman2: {
        file: "/assets/photography/portraitWoman2.jpeg",
    },
    portraitWoman3: {
        file: "/assets/photography/portraitWoman3.jpeg",
    },
    portraitWoman4: {
        file: "/assets/photography/portraitWoman4.jpeg",
    },
    portraitWoman5: {
        file: "/assets/photography/portraitWoman5.jpeg",
    },
    portraitWoman6: {
        file: "/assets/photography/portraitWoman6.jpeg",
    },
    portraitWoman7: {
        file: "/assets/photography/portraitWoman7.jpeg",
    },
    portraitWoman8: {
        file: "/assets/photography/portraitWoman8.jpeg",
    },
    redLight: {
        file: "/assets/photography/redLight.jpeg",
    },
    streetLight: {
        file: "/assets/photography/streetLight.jpeg",
    },
    symetry: {
        file: "/assets/photography/symetry.jpeg",
    },
    wetLight: {
        file: "/assets/photography/wetLight.jpeg",
    },
    wetLight2: {
        file: "/assets/photography/wetLight2.jpeg",
    },
    woman1: {
        file: "/assets/photography/woman1.jpeg",
    },
    photoAli1: {
        file: "/assets/photography/photoAli1.jpg",
    },
    photoAli3: {
        file: "/assets/photography/photoAli3.jpg",
    },
    photoAli4: {
        file: "/assets/photography/photoAli4.jpg",
    },
    photoAli6: {
        file: "/assets/photography/photoAli6.jpg",
    },
    photoAli8: {
        file: "/assets/photography/photoAli8.jpg",
    },
    dashaAli: {
        file: "/assets/photography/dashaAli.jpg",
    },
    flowers1: {
        file: "/assets/photography/flowers1.jpg",
    },
    flowers2: {
        file: "/assets/photography/flowers2.jpg",
    },
    flowers3: {
        file: "/assets/photography/flowers3.jpg",
    },
    flowers4: {
        file: "/assets/photography/flowers4.jpg",
    },
    flowers5: {
        file: "/assets/photography/flowers5.jpg",
    },
    flowers6: {
        file: "/assets/photography/flowers6.jpg",
    },
    flowers7: {
        file: "/assets/photography/flowers7.jpg",
    },
    flowers8: {
        file: "/assets/photography/flowers8.jpg",
    },
    brokenGlass: {
        file: "/assets/photography/brokenGlass.jpg",
    }
}